import { render, staticRenderFns } from "./LoanCollateral.vue?vue&type=template&id=1c7d78ac&"
import script from "./LoanCollateral.vue?vue&type=script&lang=js&"
export * from "./LoanCollateral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports